import { ApiErrorResponseWithCode } from '@vfde-sails/utils';
import { AppAction } from './enum';
import { JarvisProduct } from '../../interface';

export const setLoading = (isLoading = true) => ({
    type: AppAction.SET_LOADING as const,
    isLoading,
});

export const setError = (error?: Error | ApiErrorResponseWithCode) => ({
    type: AppAction.SET_ERROR as const,
    error,
});

export const setProductDetails = (product: JarvisProduct) => ({
    type: AppAction.SET_PRODUCT_DETAILS as const,
    product,
});

export const getProductDetails = () => ({
    type: AppAction.GET_PRODUCT_DETAILS as const,
});

export type Actions = ReturnType<typeof setLoading>
    | ReturnType<typeof setError>
    | ReturnType<typeof setProductDetails>
    | ReturnType<typeof getProductDetails>;
